<template>
  <div class="SayfaContainer">
    <div class="SayfaBaslik">
      <h1>Cari İşlemleri</h1>
      <div class="SayfaBtn el-button-group">
        <el-button size="small" type="default" @click="SayfaYukle" :disabled="lo">yenile</el-button>
        <el-button size="small" type="default" @click="CariModalDurum=true" :disabled="lo">Cari Ekle</el-button>
      </div>
    </div>
    <div class="SayfaIcerik SayfaTable" v-loading="lo">
      <el-table
          v-if="Liste"
          class="table-xs table-hover"
          :data="Liste.filter(data => !Kelime || data.Grup.toLowerCase().includes(Kelime.toLowerCase()) || data.Unvan.toLowerCase().includes(Kelime.toLowerCase()) || data.id.toLowerCase().includes(Kelime.toLowerCase()))"
          @current-change="TableSecim"
          :height="Height">
        <el-table-column label="Kod" prop="id" width="75"></el-table-column>
        <el-table-column label="Ünvan" prop="Unvan"></el-table-column>
        <el-table-column label="Telefon" prop="Telefon" width="100"></el-table-column>
        <el-table-column label="Bakiye" align="right" prop="Bakiye" width="100"></el-table-column>
        <el-table-column
            align="right" label="Grup" prop="Grup" width="250" class-name="tablearama">
          <template slot="header" slot-scope="scope">
            <el-input
                v-model="Kelime"
                size="mini"
                class="tablearamainput"
                placeholder="Arama Yapın"/>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <CariModal :Durum="CariModalDurum" @Durum="CariModalDurum=false"></CariModal>
  </div>
</template>

<script>
import CariModal from "./Comp/CariModal";

export default {
  components: {CariModal},
  data() {
    return {
      Kelime: '',
      CariModalDurum: false,
      lo: false,
      Liste: [],
      Height: null
    }
  },
  methods: {
    TableSecim(e) {
      this.$router.push('/muhasebe/cari/' + e.id)
    },
    SayfaYukle() {
      this.lo = true
      this.$store.dispatch("Get", {path: 'cari'})
          .then(response => {
            if (response.Durum === "OK") {
              this.Liste = response.Liste
              this.lo = false
            } else {
              this.$notify.error({
                title: response.Mesaj,
                customClass: 'error'
              });
              this.lo = false
            }
          })
    }
  },
  created() {
    this.SayfaYukle()
    this.Height = window.innerHeight - 111
    this.$store.dispatch("title", "Cari");
  }
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/pages/Muhasebe/Cari/Index.vue